<template>
  <div v-if="users && selecteditems">
    <div class="assignee-container">
      <div :class="[{ 'w-100': show_names, 'selected-assignee': selecteditems && selecteditems.id === value }]">

        <v-list-item class="px-1">
          <template v-slot:prepend>
            <div class="border-selected">
              <v-avatar v-if="selecteditems.avatar" :image="selecteditems.avatar" :size="size"
                :class="['rounded-xl assignee-avatar']">
              </v-avatar>

              <v-avatar v-else color="var(--primary)" :size="size" class="rounded-xl assignee-avatar">
                <small v-if="selecteditems" :class="['mb-0 text-white']">
                  {{ selecteditems.first_name[0] }}{{ selecteditems.last_name[0] }}
                </small>
              </v-avatar>
            </div>
          </template>
          <v-list-item-title v-if="show_names && selecteditems">{{ selecteditems.first_name }} {{
    selecteditems.last_name
  }}</v-list-item-title>
          <v-list-item-subtitle v-if="show_names && selecteditems && show_companyname">
            {{ selecteditems.company_name
            }}
          </v-list-item-subtitle>
        </v-list-item>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="assignee-container cursor-pointer">
      <v-list-item class="px-1">
        <template v-slot:prepend>
          <div class="border-selected">
            <v-avatar color="var(--neutral-100)" :size="size" :class="['rounded-xl assignee-avatar']">
              <v-icon size="18" color="#bbbbbb">fal fa-user</v-icon>
            </v-avatar>
          </div>
        </template>
        <v-list-item-title v-if="show_names && placeholder">{{ placeholder }}</v-list-item-title>
      </v-list-item>
    </div>
  </div>
</template>
<script>
export default {
  name: "assignee",
  props: {
    users: {
      type: Array,
      required: true,
      default: () => [],
    },
    show_names: {
      type: Boolean,
      default: false,
    },
    show_companyname: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: ""
    },
    selected: {
      type: Number,
      required: true,
      default: 0
    },
    hideLastName: {
      type: Boolean,
      default: false
    },
    ticket_id: {
      type: Number,
      default: null
    },
    value: {
      type: Array, Number,
      required: false,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "Assignee"
    },
    size: {
      type: String,
      default: "x-small"
    }
  },
  data() {
    return {
      loadedUsers: [],
    };
  },
  computed: {
    selecteditems() {
      if (this.selected === null || this.selected === undefined) {
        return null;  // Explicitly return null if selected is invalid
      }
      return this.users.find(item => item.id === this.selected) || null;
    }
  },
  methods: {
    fullName(selecteditems) {
      return selecteditems.first_name + ' ' + selecteditems.last_name;
    }

  },
  created() {
    this.loadedUsers = this.users;
  }
};
</script>
